import {requests} from "../../helpers/api.services";
import {MAGAZINE_URL} from "../../helpers/api.routes";

export const MagazineSettingsService = {
    get: () => requests.get(`${MAGAZINE_URL}/settings/data`),
    update: (text: string) => requests.put(`${MAGAZINE_URL}/settings/data`, {text}),
    delete: () => requests.delete(`${MAGAZINE_URL}/settings/data`)
}